import React, { useContext, useEffect, useState } from "react";
// react-bootstrap components
import { Card, Container, Row, Col } from "react-bootstrap";
import { apiService } from "../../../service/ApiService";
import { useHistory } from "react-router-dom";
import { notificationService } from "../../../service/NotificationService";
import HippoTable from "../../../components/ReactTable/HipposReactTable";
import CreateTableBtn from "components/Buttons/CreateTableBtn";
import SweetAlert from "react-bootstrap-sweetalert";
import UserCreditsContext from "contexts/UserCreditsContext";
import TimestampColumn from "components/Custom/TimestampColumn";
import ExpirationColumn from "components/Custom/ExpirationColumn";
import LicenseStatusColumn from "components/Custom/LicenseStatusColumn";
import EditButton from "views/Components/EditButton";
import DeleteButton from "views/Components/DeleteButton";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function LicenseListPage() {
  const { t } = useTranslation();

  const history = useHistory();
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const { refreshCredits, setRefreshCredits } = useContext(UserCreditsContext);

  const alertLicenseDelete = (license) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("messages.deleteLicense")}
        onConfirm={() => deleteLicense(license.id)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        confirmBtnText={t("common.actions.delete")}
        cancelBtnText={t("common.actions.cancel")}
        showCancel
      >
        {t("messages.doYouWantToDeleteLicense")}
        {license.friendlyName}
        {t("messages.theLicenseCreditsWillBeReturnedToYourAccount")}
      </SweetAlert>
    );
  };

  const deleteLicense = async (licenseId) => {
    try {
      await apiService.delete(`api/v1/licenses/${licenseId}`);
      setAlert(null);
      setRefreshCredits(true);
      fetchData();
    } catch (error) {
      console.error(error);
      notificationService.notifyError(t("messages.unableToDelete"));
      setAlert(null);
    }
  };

  const columns = [
    {
      Header: "ID",
      accessor: "id",
      maxWidth: 70,
      minWidth: 40,
      width: 60,
    },
    {
      Header: t("tables.headers.designation"),
      accessor: "friendlyName",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.user"),
      accessor: "assignedUserUsername",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.store"),
      accessor: "storeName",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: "CREDITS",
      accessor: "totalCost",
      minWidth: 80,
      maxWidth: 150,
      width: 100,
    },
    {
      Header: t("tables.headers.createdAt"),
      accessor: "createdAt",
      minWidth: 200,
      maxWidth: 400,
      width: 500,
    },
    {
      Header: t("tables.headers.expiresAt"),
      accessor: "expiresAt",
      minWidth: 200,
      maxWidth: 400,
      width: 500,
    },
    {
      Header: t("tables.headers.status"),
      accessor: "status",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.actions"),
      accessor: "actions",
      maxWidth: 100,
      minWidth: 30,
      width: 60,
    },
  ];

  const fetchData = async () => {
    try {
      setShowLoader(true);
      const dataResponse = await apiService.get("api/v1/licenses");
      const data = dataResponse.data;
      setData(attachCustom(data));
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const attachCustom = (data) => {
    const enhanced = data.map((el) => {
      el.actions = (
        <div className="actions-right d-flex float-right">
          <EditButton uri={`/admin/license/${el.id}`} />
          {!el.storeId ? <DeleteButton handler={() => alertLicenseDelete(el)} /> : ""}
        </div>
      );
      el.createdAt = <TimestampColumn timestamp={el.createdAt} />;
      el.status = <LicenseStatusColumn expiresAt={el.expiresAt} />;
      el.expiresAt = <ExpirationColumn timestamp={el.expiresAt} />;
      el.assignedUserUsernameReseller = el.assignedUserUsername;
      return el;
    });
    return _.sortBy(enhanced, ["order", "id"]);
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (apiService.isSuperAdmin()) {
    columns.splice(2, 0, {
      Header: t("common.labels.toReseller"),
      accessor: "assignedUserUsernameReseller",
    });
  }

  return (
    <>
      {alert}
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Body>
                <Row>
                  <CreateTableBtn route={"/admin/license"} />
                </Row>
                <Row>
                  <Col>
                    {showLoader ? (
                      <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
                        <ClipLoader size={50} color={"#ff6fbc"} />
                      </div>
                    ) : (
                      <HippoTable data={data} columns={columns} className="-striped -highlight primary-pagination" />
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default LicenseListPage;
